import { IUser } from './index';
export interface IInAppNotification {
  id: string;
  title: IInAppNotificationContent;
  content: IInAppNotificationContent;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: { [key: string]: any };
  template: { identifier: string };
  subscriberId: string;
  subscriber: IUser;
  templateId: string;
  readAt: string;
  createdAt: string;
  updatedAt: string;
}
interface IInAppNotificationContent extends Record<string, string> {
  en: string;
  fi: string;
  sv: string;
}
export interface IGroupedNotifications {
  date: string;
  notifications: IInAppNotification[];
}
export enum NotificationTemplate {
  TASK_DUE = 'task-due',
  TASK_ALERT = 'task-alert',
  CRITICAL_TASK_DUE = 'critical-task-due',
  CRITICAL_TASK_ALERT = 'critical-task-alert',
  MATTER_OPENED = 'matter-opened',
  PRELIMINARY_INVOICE_REVIEW = 'preliminary-invoice-review',
  PRELIMINARY_INVOICE_APPROVAL = 'preliminary-invoice-approval',
}
